import {
    Avatar,
    CardContent,
    CardHeader,
    Divider,
    makeStyles,
    Typography,
} from "@material-ui/core";
import Cookies from "js-cookie";
import React from "react";
import config from "../../../config/apiConfig";

type Review = {
    id: 1;
    userId: number;
    storyId: string;
    replyOn: number;
    comment: string;
    chapterId: string | null;
    userName: string;
    rating: number;
    writerRating: number;
};

const requestParams = {
    method: "POST",
    body: null,
    headers: {
        "Access-Control-Allow-Origin": "*",
        session_token: Cookies.get("token") ?? "",
        token: config.token,
    },
};

const useStyles = makeStyles((theme) => ({
    flex: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    },
    ratingBox: {
        border: "1.5px solid #eee",
        padding: theme.spacing(2),
        marginBottom: theme.spacing(1),
        borderRadius: 8,
    },
}));

const CommunitySection: React.FC<{ id: string }> = ({ id }) => {
    const [reviews, setReviews] = React.useState<Review[]>([]);
    const [index, setIndex] = React.useState<number>(0);

    const classes = useStyles();

    React.useEffect(() => {
        fetch(
            `${config.BASE_URL}/v2/api/review/getCommunityReview?storyId=${id}&count=10`,
            requestParams
        )
            .then((res) => res?.json())
            .then((res) => setReviews(res || []));
    }, []);

    const setRating = (index: number, rating: number) => {
        const oldRating = reviews[index].writerRating;
        const reviewId = reviews[index].id;
        const newReviews = [...reviews];
        newReviews[index].writerRating = rating;
        setReviews(newReviews);
        fetch(
            config.BASE_URL +
                "/v2/api/writer/rateCommunity?id=" +
                reviewId +
                "&rating=" +
                rating,
            requestParams
        )
            .then((res) => res?.json())
            .then((res) => {
                if (!res) {
                    newReviews[index].writerRating = oldRating;
                    setReviews(newReviews);
                }
            })
            .catch((err) => {
                newReviews[index].writerRating = oldRating;
                setReviews(newReviews);
            });
    };

    return (
        <React.Fragment>
            <CardContent className={classes.flex}>
                <Typography variant="subtitle1" color="textSecondary">
                    Showings {reviews.length} reviews from the community
                </Typography>
            </CardContent>
            <Divider />
            {reviews.map((review, index) => (
                <React.Fragment key={index}>
                    <CardHeader
                        avatar={
                            <Avatar style={{ background: "#eee" }}>
                                {review.userName.charAt(0)}
                            </Avatar>
                        }
                        title={review.userName}
                    />
                </React.Fragment>
            ))}
        </React.Fragment>
    );
};

export default CommunitySection;
